import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function usePostIamAttachAvatar() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { avatar: File }) => {
      const formData = new FormData();
      formData.append('avatar', params.avatar);

      const response = await fetch('/agent/api/iam/attach_avatar', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Failed to attach avatar');
      }
      return await response.json();
    },
    onSuccess: () => {
      // IAMデータのキャッシュを無効化して、最新のデータを取得
      queryClient.invalidateQueries({ queryKey: ['iam'] });
    },
  });
}
